import React, { Component } from "react";
import { connect } from 'react-redux';
import { addToCart, removeFromCart } from '../store/actions/productActions';

class Counter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: this.props.cart[this.props.product.id].quantity,
      editing: false,
      inputVal: '',
    };
    this.inputRef = React.createRef();
    this.handleRemove = this.handleRemove.bind(this);
    this.handleAdd    = this.handleAdd.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.newState     = this.newState.bind(this);
  }

  handleAdd(product) {
    const curQty = this.props.cart[product.id] ? this.props.cart[product.id].quantity : 0;
    if (curQty >= 99) return;
    this.props.addToCart(product);
    this.newState(product.id);
  }

  handleRemove(product) {
    const currentQty = this.props.cart[product.id] ? this.props.cart[product.id].quantity : 0;
    this.props.removeFromCart(product);
    if (currentQty <= 1) {
      if (this.props.fromCart) this.props.callNewCart && this.props.callNewCart();
      else this.props.changeCounter();
    } else {
      this.newState(product.id);
    }
  }

  handleDelete(product) {
    const qty = this.props.cart[product.id] ? this.props.cart[product.id].quantity : 0;
    for (let i = 0; i < qty; i++) this.props.removeFromCart(product);
    if (this.props.fromCart) this.props.callNewCart && this.props.callNewCart();
    else this.props.changeCounter();
  }

  newState(id) {
    this.setState(
      { quantity: this.props.cart[id].quantity },
      function() { this.props.newQuantity && this.props.newQuantity(this.state.quantity); }
    );
  }

  startEdit = () => {
    const origQty = this.state.quantity;
    this.setState({ editing: true, inputVal: String(origQty), origQty }, () => {
      this.inputRef.current && this.inputRef.current.select();
    });
  };

  commitEdit = () => {
    const product = this.props.product;
    const newQty  = Math.min(99, Math.max(1, parseInt(this.state.inputVal, 10) || 0));
    const origQty = this.state.origQty || this.state.quantity; // frozen at edit start

    if (!newQty) {
      this.setState({ editing: false });
      this.handleDelete(product);
      return;
    }

    const diff = newQty - origQty;
    if (diff > 0) { for (let i = 0; i < diff; i++) this.props.addToCart(product); }
    else if (diff < 0) { for (let i = 0; i < Math.abs(diff); i++) this.props.removeFromCart(product); }

    this.setState({ editing: false, quantity: newQty, origQty: null });
    this.props.newQuantity && this.props.newQuantity(newQty);
  };

  render() {
    const product  = this.props.product;
    const type     = product.quantity_type === 'kg' ? ' kg' : '';
    const { editing, inputVal, quantity } = this.state;

    return (
      <div className="stepper-input">
        <div className="delete-btn" onClick={() => this.handleDelete(product)} title="Remove from cart">×</div>
        <div className="decrement" onClick={() => this.handleRemove(product)}>–</div>

        {editing ? (
          <input
            ref={this.inputRef}
            id="counter-qty" name="counter-qty"
            type="number"
            min="1"
            max="99" autoComplete="off"
            value={inputVal}
            onChange={e => this.setState({ inputVal: e.target.value })}
            onBlur={this.commitEdit}
            onKeyDown={e => { if (e.key === 'Enter') e.target.blur(); if (e.key === 'Escape') this.setState({ editing: false }); }}
            className="quantity"
            style={{ width:'36px', textAlign:'center', border:'none', background:'transparent', fontSize:'inherit', fontFamily:'inherit', fontWeight:'inherit', color:'inherit', outline:'none', MozAppearance:'textfield', WebkitAppearance:'none', cursor:'text', padding:0, margin:0 }}
          />
        ) : (
          <div className="quantity" onClick={this.startEdit} style={{ cursor:'text' }}>
            {(quantity * Number(product.quantity_single)) + type}
          </div>
        )}

        <div className="increment" onClick={() => this.handleAdd(product)}>+</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({ cart: state.cart });
const mapDispatchToProps = dispatch => ({
  addToCart:      (product) => dispatch(addToCart(product)),
  removeFromCart: (product) => dispatch(removeFromCart(product)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Counter);
